import { ftToPx, pxToFt } from '@peles/shared';
import { gridLines } from './helpers';
import { useCanvasPalette } from './canvasPalette';

interface GridLinesProps {
  /** The canvas, in pixels. */
  widthPx: number;
  heightPx: number;
  /** The plan's grid, in feet. */
  gridSizeFt: number;
}

/**
 * A plan's grid, drawn inside the canvas SVG: a line every grid step across
 * and down, the heavier major lines every 5 ft on a fine grid and every fifth
 * line on a coarse one (`gridLines`).
 */
export function GridLines({ widthPx, heightPx, gridSizeFt }: GridLinesProps) {
  const palette = useCanvasPalette();
  const majorLine = { stroke: palette.gridMajor, strokeWidth: 0.5 };
  const minorLine = { stroke: palette.gridMinor, strokeWidth: 0.25 };
  return (
    <g data-testid="grid-lines" pointerEvents="none">
      {gridLines(pxToFt(widthPx), gridSizeFt).map(({ ft, major }) => (
        <line
          key={`v${ft}`}
          x1={ftToPx(ft)}
          y1={0}
          x2={ftToPx(ft)}
          y2={heightPx}
          {...(major ? majorLine : minorLine)}
          data-testid="grid-line-v"
        />
      ))}
      {gridLines(pxToFt(heightPx), gridSizeFt).map(({ ft, major }) => (
        <line
          key={`h${ft}`}
          x1={0}
          y1={ftToPx(ft)}
          x2={widthPx}
          y2={ftToPx(ft)}
          {...(major ? majorLine : minorLine)}
          data-testid="grid-line-h"
        />
      ))}
    </g>
  );
}
